







import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class AEiLoading extends Vue {
  @Prop()
  height!: string;

  @Prop()
  width!: string;
  get chatAiSvg() {
    return require("@/assets/undraw/undraw_chat-with-ai_ir62.svg");
  }
}
